import { render, staticRenderFns } from "./FeeVouchersComponent.vue?vue&type=template&id=60d97fca&"
import script from "./FeeVouchersComponent.vue?vue&type=script&lang=js&"
export * from "./FeeVouchersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports